import { Button } from "@material-ui/core"
import React, { useState } from "react"
import CustomAlert from "../../Componentes/Alerts/CustomAlert"
import Topo from "../../Componentes/TopCategorias"
import { useProduct } from "../../ContextAPI/productContext"
import api from "../../Services/api"
import VendidosContainer from "./DragAndDropDestaques/VendidosContainer"
import { TextField } from "@material-ui/core"
import maisVendidosRequest from "../../Services/api/maisvendidos"
import { useEffect } from "react"
import { Autocomplete } from "@material-ui/lab"
import newsRequest from "../../Services/api/news"

export default function MaisVendidos() {
  const errorStyle = {
    color: "red",
    fontSize: "0.9rem"
  }

  const { vendidosList, setVendidosList } = useProduct()
  const [alertType, setAlertType] = useState("")
  const [showAlertOk, setShowAlertOk] = useState(false)
  const [showAlertError, setShowAlertError] = useState(false)
  const [sales, setSales] = useState([])
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [errorProductExist, setErrorProductExist] = useState(false)

  const closeAlerts = () => {
    setShowAlertOk(false)
    setShowAlertError(false)
  }

  async function getOptions() {
    try {
      const data = await newsRequest.getOptions()
      setOptions(data.data.data)
    } catch (error) {}
  }

  useEffect(() => {
    getOptions()
  }, [])

  async function handleGetSalesList() {
    setLoading(true)
    try {
      const resProduct = await api.get(`/v2/lojinha/products/top/list`)
      if (resProduct) {
        setVendidosList(resProduct.data.data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handleGetSalesList()
  }, [])

  async function handleSaveVendidosList() {
    const productsIds = vendidosList.map(product =>
      product.id ? product.id : product.product_id
    )

    try {
      const { data } = await maisVendidosRequest.put({
        top_body: productsIds
      })
      if (data) {
        setAlertType("success")
        setShowAlertOk(true)
        handleGetSalesList()
      } else {
        setAlertType("error")
        setShowAlertError(true)
      }
    } catch (error) {}
    console.log(error)
  }
  return (
    <>
      <div className="page-container">
        <div className="page-align">
          <Topo name="Mais vendidos" />
          <div className="infinite-scroll">
            <div style={{ marginBottom: "1rem" }}>
              <Autocomplete
                id="tags-standard"
                onChange={(event, newValue) => {
                  if (newValue) {
                    const isProductExist = vendidosList?.some(
                      existingProduct =>
                        existingProduct.product_title === newValue.product_title
                    )

                    if (isProductExist) {
                      setErrorProductExist(true)
                      return
                    }
  
                    if (newValue && !isProductExist) {
                      setVendidosList(prevList => [...prevList, newValue])
                      setErrorProductExist(false)
                      return
                    }
                  }
                }}
                options={options}
                getOptionLabel={sale => sale.product_title}
                renderInput={params => (
                  <TextField {...params} variant="standard" placeholder="Produtos" />
                )}
                renderOption={(props, option) => (
                  <li {...props}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={props.product_image}
                        alt={props.product_title}
                        style={{ width: 50, marginRight: 10 }}
                      />
                      {props.product_title}
                    </div>
                  </li>
                )}
              />
  
              {errorProductExist && (
                <p style={errorStyle}>Esse produto já está selecionado.</p>
              )}
            </div>
            <div className="infinite-scroll">
              <VendidosContainer
                handleGetSalesList={handleGetSalesList}
                loading={loading}
              />
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center"
              }}
            >
              <CustomAlert
                type={alertType}
                alertText={
                  alertType === "success"
                    ? "Dados salvos com sucesso!"
                    : "Algo deu errado!"
                }
                show={showAlertOk || showAlertError}
                close={() => closeAlerts()}
              />
            </div>
          </div>

          <div className="footer-column">
            <hr style={{ width: "100%" }} />
            <Button
              onClick={() => handleSaveVendidosList()}
              style={{
                color: "#fff",
                minWidth: "100%",
                height: "50px",
                boxShadow:
                  "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
                marginTop: "5px",
                marginBottom: "15px",
                textTransform: "none",
                backgroundColor: "#EA3458"
              }}
              type="submit"
              variant="contained"
            >
              Salvar alterações
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
